import { render, staticRenderFns } from "./SidebarServiceComponent.vue?vue&type=template&id=1a2cbd06&scoped=true&"
import script from "./SidebarServiceComponent.vue?vue&type=script&lang=js&"
export * from "./SidebarServiceComponent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarServiceComponent.vue?vue&type=style&index=0&id=1a2cbd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2cbd06",
  null
  
)

export default component.exports